// This component fetches and displays trending facet-based product recommendations.
// It uses `useRecommendationProducts` with the `trending-facets` model and shows a loading state.
// Products are rendered in a horizontal carousel via `AlgoliaRecommendationCarousel`.

import React from 'react';
import AlgoliaRecommendationCarousel from './AlgoliaRecommendationCarousel';
import useRecommendationProducts from 'helpers/hooks/useRecommendationProducts';
import Loading from 'components/commercetools-ui/atoms/loading';
import { P2Badge } from '../product-list-algolia/types';
import ProductTileSlider from '../../ProductTile-Slider';

function TrendingFacetsRecommendation({
  title,
  p1BadgeData,
  p2BadgeData,
}: {
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
}) {
  return <AlgoliaRecommendationCarouselWrapper title={title} p1BadgeData={p1BadgeData} p2BadgeData={p2BadgeData} />;
}

function AlgoliaRecommendationCarouselWrapperComponent({
  title,
  p1BadgeData,
  p2BadgeData,
}: {
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
}) {
  const { items } = useRecommendationProducts({ model: 'trending-facets' });
  if (items === undefined) return <Loading text="Loading recommendations..." />;
  return (
    // <AlgoliaRecommendationCarousel title={title || 'Trending Facets'} items={items} />
    <ProductTileSlider
      title={title || 'Trending Items'}
      p1BadgeData={p1BadgeData}
      p2BadgeData={p2BadgeData}
      items={items}
    />
  );
}

const AlgoliaRecommendationCarouselWrapper = React.memo(AlgoliaRecommendationCarouselWrapperComponent);
AlgoliaRecommendationCarouselWrapper.displayName = 'AlgoliaRecommendationCarouselWrapper';

export default TrendingFacetsRecommendation;
